import React, { Component , Fragment } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../translations";

class CounterOne extends Component{
    static contextType = LanguageContext;

    state = {
        didViewCountUp: false
    };
    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({didViewCountUp: true});
        }
    }
    render(){
        const { language } = this.context;
        const t = translations[language];

        let Data = [
            {
                countNum : 35,
                countTitle: t.homepage.funFacts.experience || 'Years of Combined Professional Experience',
            },
            {
                countNum : 100,
                countTitle: t.homepage.funFacts.projects || 'Projects Delivered with Excellence',
            },
            {
                countNum : 98,
                countTitle: t.homepage.funFacts.satisfaction || 'Client Satisfaction Rate',
            },
        ];

        return(
            <Fragment>
                <div className="row">
                    {Data.map( (value, index) => (
                        <div className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                            <h5 className="counter">
                                <VisibilitySensor onChange={this.onVisibilityChange} offset={{top:10}} delayedCall>
                                    <CountUp end={this.state.didViewCountUp ? value.countNum : 0} />
                                </VisibilitySensor>
                            </h5>
                            <p className="description">{value.countTitle}</p>
                        </div>
                    ))}
                </div>
            </Fragment>
        )
    }
}
export default CounterOne;